import { forwardRef } from 'react'

import {
  CloseFullscreenRounded,
  RestartAltRounded,
  ZoomOutRounded,
} from '@mui/icons-material'
import { Box, Button, Dialog, Grow, Typography } from '@mui/material'

import { LoadingOverlay } from '@common/components'
import { Chart } from '@common/components/chart'

const Transition = forwardRef((props, ref) => <Grow ref={ref} {...props} />)

export default function FullscreenChartCard({ open, onClose, cardData = undefined }) {
  const {
    title,
    category,
    loading,
    data,
    dataTypes,
    zoomedData,
    zoomState,
    highlightedAreas,
    noiseThresholdRules,
    yMin,
    yMax,
    settings,
    handleZoomOut,
    handleZoomReset,
  } = cardData ?? {}

  const isZoomed = zoomState?.selectedAreaState?.[0]

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{ margin: 4 }}
      maxWidth={false}
      slots={{ transition: Transition }}
      slotProps={{
        paper: {
          style: {
            backgroundImage: 'unset',
            boxShadow: 'none',
            width: '100%',
            padding: 30,
          },
        },
      }}
    >
      <LoadingOverlay loading={loading}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={4}>
          <Box display="flex" gap={3} alignItems="center">
            <Typography variant="h4">{title}</Typography>
            {isZoomed && (
              <Box display="flex" alignItems="center" gap={2}>
                <Button
                  size="small"
                  startIcon={<ZoomOutRounded />}
                  variant="outlined"
                  onClick={handleZoomOut}
                >
                  Zoom Out
                </Button>
                <Button
                  size="small"
                  startIcon={<RestartAltRounded />}
                  variant="outlined"
                  onClick={handleZoomReset}
                >
                  Reset Zoom
                </Button>
              </Box>
            )}
          </Box>
          <Box onClick={onClose} sx={{ cursor: 'pointer' }}>
            <CloseFullscreenRounded sx={{ fontSize: 28 }} />
          </Box>
        </Box>
        {cardData && (
          <Chart
            id={`fullscreen_${category}`}
            data={data}
            zoomedData={zoomedData}
            highlightedAreas={highlightedAreas}
            dataTypes={dataTypes}
            noiseThresholdRules={noiseThresholdRules}
            zoomState={zoomState}
            yMin={yMin}
            yMax={yMax}
            height={500}
            settings={{
              ...settings,
              bottomAxisProps: { tick: { fontSize: '14px' } },
              rightAxisProps: {
                tick: { fontSize: '14px' },
                label: { fontSize: '16px' },
              },
            }}
          />
        )}
      </LoadingOverlay>
    </Dialog>
  )
}
